import {tmpGroup} from "../../main";
import {Mesh, PlaneGeometry, Vector3, Box3} from "three";
import * as Globals from "../../globals";
import {toFixedFloat} from "../../utils/utils";
import {setObjectLayer} from "../../utils/layerUtils";
import {previewMaterial} from "../../constants/materialConstants";
import {getWallOrientation} from "../walls/wall";

const wallVectorOffset = 0.5 * Globals.HBEWallDefaultThickness;
const previewYPosition = 4;
const measurementDirection = {
    negativeZ: 1,
    positiveX: 2,
    positiveZ: 3,
    negativeX: 4
};

export class MeasurementPreview {
    constructor(sel1, sel2, pos1, pos2) {
        let sel1Orientation = getWallOrientation(sel1);
        let sel2Orientation = getWallOrientation(sel2);
        if (sel1Orientation == 'z' && sel1Orientation != sel2Orientation) {
                let tempPos = pos1;
                pos1 = pos2;
                pos2 = tempPos;
                let tempSel = sel1;
                sel1 = sel2;
                sel2 = tempSel;
                this.sel1Orientation = sel2Orientation;
                this.sel2Orientation = sel1Orientation;
        } else if (sel1Orientation == 'z' && sel2Orientation == 'z' && sel1.position.x < sel2.position.x) {
                let tempPos = pos1;
                pos1 = pos2;
                pos2 = tempPos;
                let tempSel = sel1;
                sel1 = sel2;
                sel2 = tempSel;
                this.sel1Orientation = sel2Orientation;
                this.sel2Orientation = sel1Orientation;
        } else {
            this.sel1Orientation = sel1Orientation;
            this.sel2Orientation = sel2Orientation;
        }
        this.pos1 = pos1;
        this.pos2 = pos2;
        this.from = pos1.clone();
        this.to = pos2.clone();
        this.firstMeasurement = null;
        this.secondMeasurement = null;

        this.group = tmpGroup;
    }

    createFirstMeasurement() {
        let directionVector = this.calculateDirectionVectorX();
        let length = toFixedFloat(directionVector.length(), 5);
        directionVector.clampLength(length, length);
        let position = new Vector3().copy(this.to).add(new Vector3().copy(directionVector).multiplyScalar(0.5));
        position.y = previewYPosition;
        this.firstMeasurement = this.createPreviewMesh(length, position);
        this.firstMeasurement.userData.direction = measurementDirection.positiveX;
    }

    createSecondMeasurement() {
        let directionVector = this.calculateDirectionVectorZ();
        let length = toFixedFloat(directionVector.length(), 5);
        directionVector.clampLength(length, length);
        let position = new Vector3().copy(this.to).add(new Vector3().copy(directionVector).multiplyScalar(0.5));
        position.y = previewYPosition;
        this.secondMeasurement = this.createPreviewMesh(length, position);
        this.secondMeasurement.userData.direction = measurementDirection.positiveZ;
        this.secondMeasurement.rotation.y = Math.PI / 2;
    }

    createPreviewMesh(length, position) {
        let geometry = new PlaneGeometry(length, Globals.HBEMeasureDefaultThickness);
        geometry.rotateX(Math.PI / 2); //Rotieren um auf x/z zu liegen
        let previewMesh = new Mesh(geometry, previewMaterial);
        previewMesh.name = "wallPreview";
        setObjectLayer(previewMesh, Globals.layers.layoutViewOnly);

        previewMesh.position.copy(position);

        return previewMesh;
    }

    calculateDirectionVectorX() {
        let offset  = new Vector3(wallVectorOffset, 0, 0);
        if (this.sel1Orientation == 'z') { //vertical sel1
            if (this.from.x < this.to.x) {
                this.from.add(offset); //decrease x
            } else {
                this.from.sub(offset); //increase x
            }
        }

        if (this.sel2Orientation == 'z') { //vertical sel2
            if (this.to.x > this.from.x) {
                this.to.sub(offset); //decrease x
            } else {
                this.to.add(offset); //increase x
            }
        }

        let directionVector = new Vector3().subVectors(this.from, this.to);
        directionVector.setY(0);
        directionVector.setZ(0);

        let currentLength = directionVector.length();

        directionVector.clampLength(currentLength, currentLength);

        return directionVector;
    }

    calculateDirectionVectorZ() {
        let offset  = new Vector3(0, 0, wallVectorOffset);
        if (this.sel1Orientation == 'x') { //horizontal sel1
            if (this.from.x != this.to.x) { //sel1 is left or right to sel2
                if (this.from.z < this.to.z) { // sel1 above sel2
                    this.from.add(offset); //increase z
                } else { // below sel2
                    this.from.sub(offset); //decrease z
                }
            }
        }

        if (this.sel2Orientation == 'x') { //horizontal sel2
            if (this.from.x != this.to.x) { //sel1 is left or right to sel2
                if (this.to.z > this.from.z) { // above sel2
                    this.to.sub(offset); //decrease z
                } else { // below sel2
                    this.to.add(offset); //increase z
                }
            }
        }

        let directionVector = new Vector3().subVectors(this.from, this.to);
        directionVector.setY(0);
        directionVector.setX(0);

        let currentLength = directionVector.length();

        directionVector.clampLength(currentLength, currentLength);

        return directionVector;
    }
}
